import { Box, Button } from '@mui/material'
import React from 'react'
import LoadingDrawer from '../../../components/loading/LoadingDrawer'

interface OwnProps {
  spinning: boolean
  onCancel: () => void
  onSubmit: () => void
  // TODO: craco.config.jsのprimaryにKDSの色を定義するときにこのpropsを消す
  isKds?: boolean
}

const FooterButton: React.FC<OwnProps> = (props: OwnProps) => {
  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        justifyContent: 'flex-end',
        gap: 2,
      }}
    >
      <Button
        color="secondary"
        variant="contained"
        onClick={() => props.onCancel()}
      >
        キャンセル
      </Button>
      <LoadingDrawer
        spinning={props.spinning}
        render={
          <Button
            color="primary"
            variant="contained"
            onClick={() => props.onSubmit()}
          >
            保存
          </Button>
        }
      />
    </Box>
  )
}

export default FooterButton
